import React from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import ServerPath from '../../configs/serverPath';

const CasinoButton = () => {
    const { sealCasinoPortalUrl, composePath } = useSiteInfo();

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (sealCasinoPortalUrl) {
            window.location = sealCasinoPortalUrl;
        }
    };

    return (
        <a className="btn btn--casino-royale" onClick={handleClick}>
            <i className="icon icon--gradient-third">
                <img src={composePath({ pathType: ServerPath.globalImage, pathName: 'before_nova88/ui/sport52.svg' })} />
            </i>
        </a>
    );
};

export default CasinoButton;
